module.exports = __webpack_public_path__ + "img/新百宸LOGO2.9ff8cc4f.png";